import {SubAPI} from "./SubAPI";
import {DateString} from "./Projects";

export class Report extends SubAPI {
    generate(input: {
        type: "multi-project";
        multiProjectInput: {
            activityStart?: Date;
            activityEnd?: Date;
            list?: number[];
            deepRecalculate?: boolean;
        }
    } | {
        type: "multi-product";
        multiProductInput: {
            purchasedStart?: Date;
            purchasedEnd?: Date;
            list?: number[];
        }
    }) {
        return this.fetcher.post<{
            task: string;
        }>("/api/reports/generate", input)
    }
}

export type MultiProjectReportItem = {
    id: number
    name: string;
    contractValueCents: number | null;
    contractBilledCents: number | null;
    contractCostCents: number | null;
    contractCostProjectedCents: number | null;
    changesContractValueCents: number | null;
    changesBilledCents: number | null;
    changesCostCents: number | null;
    changesCostProjectedCents: number | null;
    lastUpdatedAt: DateString;
}

export type MultiProductReportItem = {
    id: number
    name: string;
    manufacturer: string;
    productCode: string;
    inventoryRef: number | null;
    costCents: number;
    priceCents: number;
}